export default __webpack_public_path__ + "static/media/fresh-juice.173bb3bd.svg";